module.exports = __webpack_public_path__ + "img/button-text-numbered-list-on.8e7d0ec.svg";